<template>
  <TFinderLayout>
    <template #sidebar>
      <!-- Custom -->
      <div
        style="height: 100%; margin: -12px -12px 0px -12px; padding: 12px;"
        :class="$route.params.template_type === 'custom' ? 'work-bench-highlighted' : ''"
      >
        <TFlex class="color-white-04" align_items="center" style="margin-left: -10px">
          <TIcon 
            name="person"
            class="mr-1" 
            :small="$vuetify.breakpoint.smAndUp" 
            :color="`grey ${$vuetify.theme.isDark ? 'lighten-4' : 'darken-4'}`" 
          />
          <TText 
            v-if="$vuetify.breakpoint.smAndUp"
            value="My Content" 
            :color="`grey ${$vuetify.theme.isDark ? 'lighten-4' : 'darken-4'}`" 
            font_weight="400"
          />
        </TFlex>
        <TFlex
          class="cursor-pointer mb-2 mt-2"
          align_items="center"
          @click.native="$router.push({
              name: 'WorkBenchSequences',
              params: {
                template_type: 'custom',
                sfolder: 'last-updated'
              }
            })"
        >
          <div
            v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchSequences' && $route.params.template_type === 'custom'"
            :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
            />
          <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-sequence" />
          <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Sequences" />
        </TFlex>
        <TFlex
          class="cursor-pointer mb-2 mt-2"
          align_items="center"
          @click.native="$router.push({
              name: 'WorkBenchWaggons',
              params: {
                template_type: 'custom',
                wagfolder: 'last-updated'
              }
            })"
          >
          <div
            v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchWaggons' && $route.params.template_type === 'custom'"
            :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
          />
          <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-waggon" />
          <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Wagons" />
        </TFlex>
        <TFlex
          class="cursor-pointer"
          align_items="center"
          @click.native="$router.push({
              name: 'WorkBenchWorkPackages',
              params: {
                template_type: 'custom',
                wfolder: 'last-updated'
              }
            })"
          >
          <div
            v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchWorkPackages' && $route.params.template_type === 'custom'"
            :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
          />
          <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-workpackage" />
          <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Workpackages" />
        </TFlex>
        <TFlex
          class="cursor-pointer mt-2"
          align_items="center"
          @click.native="$router.push({
              name: 'WorkBenchMaterials',
              params: {
                template_type: 'custom',
                mfolder: 'last-updated'
              }
            })"
          >
          <div
            v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchMaterials' && $route.params.template_type === 'custom'"
            :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
            />
          <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="packet" />
          <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Materials" />
        </TFlex>

      </div>
      <!-- Company -->
      <template v-if="hasPermission('Business READ')">
        <v-divider class="grey darken-3 mb-3"/>
        <div
          style="height: 100%; margin: -12px -12px 0px -12px; padding: 12px;"
          :class="$route.params.template_type === 'company'?'work-bench-highlighted':''"
          >
          <TFlex class="color-white-04" align_items="center" style="margin-left: -10px">
            <TIcon 
              name="suitcase"
              class="mr-1" 
              :small="$vuetify.breakpoint.smAndUp" 
              :color="`grey ${$vuetify.theme.isDark ? 'lighten-4' : 'darken-4'}`" 
            />
            <TText 
              v-if="$vuetify.breakpoint.smAndUp"
              value="Company Content" 
              :color="`grey ${$vuetify.theme.isDark ? 'lighten-4' : 'darken-4'}`" 
              font_weight="400"
            />
          </TFlex>
          <TFlex
            class="cursor-pointer mt-2"
            align_items="center"
            @click.native="$router.push({
                name: 'WorkBenchSequences',
                params: {
                  template_type: 'company',
                  sfolder: 'last-updated'
                }
              })"
            >
            <div
              v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchSequences' && $route.params.template_type === 'company'"
              :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
              />
            <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-sequence" />
            <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Sequences" />
          </TFlex>
          <TFlex
            class="cursor-pointer mb-2 mt-2"
            align_items="center"
            @click.native="$router.push({
                name: 'WorkBenchWaggons',
                params: {
                  template_type: 'company',
                  wagfolder: 'last-updated'
                }
              })"
            >
            <div
              v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchWaggons' && $route.params.template_type === 'company'"
              :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
              />
            <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-waggon" />
            <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Wagons" />
          </TFlex>
          <TFlex
            class="cursor-pointer mt-2"
            align_items="center"
            @click.native="$router.push({
                name: 'WorkBenchWorkPackages',
                params: {
                  template_type: 'company',
                  wfolder: 'last-updated'
                }
              })"
            >
            <div
              v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchWorkPackages' && $route.params.template_type === 'company'"
              :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
              />
            <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-workpackage" />
            <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Workpackages" />
          </TFlex>
          <TFlex
            class="cursor-pointer mt-2"
            align_items="center"
            @click.native="$router.push({
                name: 'WorkBenchMaterials',
                params: {
                  template_type: 'company',
                  mfolder: 'last-updated'
                }
              })"
            >
            <div
              v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchMaterials' && $route.params.template_type === 'company'"
              :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
              />
            <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="packet" />
            <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Materials" />
          </TFlex>
        </div>
      </template>
      <!-- Community -->
      <v-divider class="grey darken-3 mb-3"/>
      <div
        style="height: 100%; margin: -12px -12px 0px -12px; padding: 12px;"
        :class="$route.params.template_type === 'community'?'work-bench-highlighted':''"
        >
        <TFlex class="color-white-04" align_items="center" style="margin-left: -10px">
          <TIcon 
            name="persons-two"
            class="mr-1" 
            :small="$vuetify.breakpoint.smAndUp" 
            :color="`grey ${$vuetify.theme.isDark ? 'lighten-4' : 'darken-4'}`" 
          />
          <TText 
            v-if="$vuetify.breakpoint.smAndUp"
            value="Community Content" 
            :color="`grey ${$vuetify.theme.isDark ? 'lighten-4' : 'darken-4'}`" 
            font_weight="400"
          />
        </TFlex>
        <TFlex
          class="cursor-pointer mb-2 mt-2"
          align_items="center"
          @click.native="$router.push({
              name: 'WorkBenchSequences',
              params: {
                template_type: 'community',
                sfolder: 'last-updated'
              }
            })"
          >
          <div
            v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchSequences' && $route.params.template_type === 'community'"
            :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
            />
          <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-sequence" />
          <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Sequences" />
        </TFlex>
        <TFlex
          class="cursor-pointer mb-2 mt-2"
          align_items="center"
          @click.native="$router.push({
              name: 'WorkBenchWaggons',
              params: {
                template_type: 'community',
                wagfolder: 'last-updated'
              }
            })"
          >
          <div
            v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchWaggons' && $route.params.template_type === 'community'"
            :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
            />
          <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-waggon" />
          <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Wagons" />
        </TFlex>
        <TFlex
          class="cursor-pointer"
          align_items="center"
          @click.native="$router.push({
              name: 'WorkBenchWorkPackages',
              params: {
                template_type: 'community'
              }
            })"
          >
          <div
            v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchWorkPackages' && $route.params.template_type === 'community'"
            :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
            />
          <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="takt-plan-workpackage" />
          <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Workpackages" />
        </TFlex>
        <TFlex
          class="cursor-pointer mt-2"
          align_items="center"
          @click.native="$router.push({
              name: 'WorkBenchMaterials',
              params: {
                template_type: 'community'
              }
            })"
          >
          <div
            v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchMaterials' && $route.params.template_type === 'community'"
            :style="`margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(${$vuetify.theme.isDark ? '255,255,255,' : '0,0,0,'}0.9)`"
            />
          <TIcon class="mr-1" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" :size="24" name="packet" />
          <TText v-if="$vuetify.breakpoint.smAndUp" font_weight="400" value="Materials" />
        </TFlex>

      </div>
    </template>
    <template #actionbar>
      <v-btn-toggle
        :value="workbench_variables.items_mini?1:0"
        @change="updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              items_mini: $event === 1?true:false
            }
          })"
        mandatory
        dense
        >
        <v-btn v-if="$route.matched[1] && $route.matched[1].name === 'WorkBenchSequences'"><v-icon>view_list</v-icon></v-btn>
        <v-btn v-else><v-icon>view_module</v-icon></v-btn>
        <v-btn><v-icon>apps</v-icon></v-btn>
      </v-btn-toggle>
      <v-spacer/>
      <!-- color="green" -->
      <v-btn
        v-if="showCreateButton()"
        height="32px"
        outlined
        class="text-none"
        @click="createEntity()"
      >
        <TIcon
          name="sign-plus"
        /> <TText :value="getCreateText()" />
      </v-btn>
      <v-btn
        v-if="showCreateButton() && getEditorRoute(0).name === 'WorkBenchWorkPackageEditor'"
        height="32px"
        outlined
        class="text-none ml-2"
        @click="$refs.select_csv_button.click()"
      >
        <TIcon
          name="upload"
        /> <TText value="Workpackages" />
      </v-btn>
      <v-btn
        v-if="$route.params.template_type === 'custom' && ['WorkBenchSequenceEditor', 'WorkBenchWaggonEditor', 'WorkBenchWorkPackageEditor', 'WorkBenchMaterialEditor'].includes(getEditorRoute(0).name)"
        height="32px"
        outlined
        class="text-none ml-2"
        @click="createFolder()"
      >
        <TIcon
          name="sign-plus"
        /> <TText value="Folder" />
      </v-btn>
      <!-- hidden input field for .csv files -->
      <input
          v-show="false"
          ref="select_csv_button"
          type="file"
          accept=".csv"
          @change="importWorkpackagesFromCSV($refs.select_csv_button.files[0])"
          />
      <v-spacer/>
      <v-btn v-if="showCreateButton() && getEditorRoute(0).name === 'WorkBenchWorkPackageEditor'" class="text-none" outlined height="32px" @click="downloadWorkpackageImportTemplate()">
        <TIcon
          name="download" size="20"
        />
        <TText :value="'Template'" />
      </v-btn>
      <v-btn 
        v-if="($route.params.template_type === 'custom' || $route.params.template_type === 'company') && getEditorRoute().name === 'WorkBenchMaterialEditor'" 
        class="text-none" outlined height="32px" 
        @click="exportMasterialCSV($route.params.template_type)"
      >
        <TIcon
          name="download" size="20"
        />
        <TText :value="'Material List'" />
      </v-btn>

      <v-btn
        v-if="($route.params.template_type === 'custom' || $route.params.template_type === 'company') && getEditorRoute().name === 'WorkBenchWorkPackageEditor'" 
        class="text-none" outlined height="32px"
        @click="exportWorkpackageCSV($route.params.template_type)"
      >
        <TIcon
          name="download" size="20"
        />
        <TText :value="'Workpackage List'" />
      </v-btn>

      <v-btn class="text-none" outlined height="32px" @click="loadData()">
        <TText :value="'Load all'" />
      </v-btn>
        <!-- <TSearchField
        height="30px"
        border_color="rgb(41,41,41)"
        :value="workbench_variables.search"
        @input="workbenchSearch($event.target.value)"
        @cancel="updateWBLObject({
          path: [
          {workbench_variables: ''}
          ],
          update: {
            search: ''
          }
          })"
          /> -->
    </template>
    <template #content>
      <router-view/>
    </template>
  </TFinderLayout>
</template>
<script>

  import TIcon from '@/components/Taktify/TIcon.component.vue'

  import { WorkBenchMixin } from '@/mixins/WorkBench.mixin.js'
  import { mapActions } from 'vuex'
  export default {
    props: [],
    components: {
      TIcon
    },
    mixins: [
      WorkBenchMixin,
    ],
    data: () => ({

    }),
    methods: {
      ...mapActions('WorkBench', [
        'createWBObject',
      ]),
      showCreateButton(){
        if (this.$route.params.template_type === 'custom') {
          return true;
        }
        if (this.$route.params.template_type === 'company' && this.$route.matched[1].name === 'WorkBenchMaterials') {
          return true;
        }
        return false;
      },
      getEditorRoute(id) {
        if (this.$route.matched[1]) {
          switch (this.$route.matched[1].name) {
            case 'WorkBenchSequences':
              return {
                name: 'WorkBenchSequenceEditor',
                params: {
                  sequence_id: id,
                  template_type: 'custom'
                }
              };
            case 'WorkBenchWorkPackages':
              return {
                name: 'WorkBenchWorkPackageEditor',
                params: {
                  workpackage_id: id,
                  template_type: 'custom'
                }
              };
            case 'WorkBenchWaggons':
              return {
                name: 'WorkBenchWaggonEditor',
                params: {
                  waggon_id: id,
                  template_type: 'custom'
                }
              };
            case 'WorkBenchMaterials':
              return {
                name: 'WorkBenchMaterialEditor',
                params: {
                  material_id: id,
                  template_type: this.$route.params.template_type,
                }
              };
            default:
              return {
                name: 'WorkBenchSequences',
                params: {
                  template_type: 'custom',
                  sfolder: 'last-updated'
                }
              };
          }
        }
      },
      getCreateText() {
        if (this.$route.matched[1]) {
          switch (this.$route.matched[1].name) {
            case 'WorkBenchSequences':
              return this.$i18n.t('WorkBench.CreateSequence');
            case 'WorkBenchWorkPackages':
              return this.$i18n.t('WorkBench.CreateWorkPackage');
            case 'WorkBenchWaggons':
              return this.$i18n.t('WorkBench.CreateWaggon');
            case 'WorkBenchMaterials':
              return this.$i18n.t('WorkBench.CreateMaterial');
            default:
              return 'None';
          }
        }
      },
      loadData(){
        this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            loading: true
          }
        });
        let prefix = '';
        switch (this.$route.params.template_type) {
          case 'custom':
            break;
          case 'company':
            prefix = 'b';
            break;
          case 'community':
            prefix = 'c';
            break;
        }
        let entity = 'workpackages';
        if (this.$route.name === 'WorkBenchSequences') {
          entity = 'sequences';
        }

        this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              search: ''
            }
          })
        this.requestWBObject({
          url: [
            {[`${prefix}${entity}`]:''},
            {showWithEntitiesNormalized: ''}
          ]
        }).then(() => {
          this.addLoadAll(`${prefix}${entity}`);
          this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              loading: false
            }
          });
        });


      },
      createFolder(){
        let folder_type;
        switch (this.getEditorRoute(0).name) {
          case 'WorkBenchSequenceEditor':
            folder_type = 'sfolder'
            break;
          case 'WorkBenchWaggonEditor':
            folder_type = 'wagfolder'
            break;
          case 'WorkBenchWorkPackageEditor':
            folder_type = 'wfolder'
            break;
          case 'WorkBenchMaterialEditor':
            folder_type = 'mfolder'
            break;
          default:
            folder_type = undefined;
        }
        // check if the $route has a param sfolder
          // check if the param is not 'last-updated'
          if (this.$route.params[folder_type] && this.$route.params[folder_type] !== 'last-updated') {
            this.createWBObject({
            url: [
              { [`${folder_type}s`]: this.$route.params[folder_type] },
              { [`${folder_type}s`]: '' },
              { 'showWithEntitiesNormalized': '' }
            ],
            wb_object: {}
          })
        } else {
          this.createWBObject({
            url: [
              { [`${folder_type}s`]: '' },
              { 'showWithEntitiesNormalized': '' }
            ],
            wb_object: {}
          })
        }

      },
      createEntity(){

        let url_entity = '';
        let path_entity = '';
        switch (this.$route.matched[1].name) {
          case 'WorkBenchSequences':
            url_entity = 'sequences';
            path_entity = 'sequence';
            break;
          case 'WorkBenchWaggons':
            url_entity = 'waggons';
            path_entity = 'waggon';
            break;
          case 'WorkBenchWorkPackages':
            url_entity = 'workpackages';
            path_entity = 'workpackage';
            break;
          case 'WorkBenchMaterials':
            url_entity = 'materials';
            path_entity = 'material';
            break;
          }

          if (url_entity === '' || path_entity === '') {
            return;
          }
          
          this.createWBObject({
            url: [
              {[`${this.prefix}${url_entity}`]: ''},
              {showWithEntitiesNormalized: ''}
            ],
            wb_object: this.$store.getters['WorkBenchLocal/getWBLObject']({
              path: [
                {[path_entity]: ''},
              ]
            })
          }).then((created_id) => {
            this.$router.push(this.getEditorRoute(created_id));
          });
  

      }
    }
  }
</script>
<style>
  .work-bench-highlighted {
    background-color:  var(--v-color-3-5-base);
  }
</style>
